<template>
  <div>
    <el-table class=""
              row-key="name"
              :data="localTableData"
              border
              style="width: 100%">
      <el-table-column
        width="190"
        label="Name">
        <template slot-scope="props">
          {{ props.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        width="180"
        label="Value">
        <template slot-scope="props">
          {{ props.row.value }}
        </template>
      </el-table-column>
      <el-table-column
        header-cell-class-name="locked-header"
        label="Locked">
        <template slot-scope="props">
          {{ props.row.locked | printBool }}
        </template>
      </el-table-column>
      <el-table-column
        header-cell-class-name="locked-header"
        label="Active">
        <template slot-scope="props">
          {{ props.row.active | printBool}}
        </template>
      </el-table-column>
      <el-table-column
        width="110"
        fixed="right"
        label="Actions">
        <template slot-scope="props">
          <div style="text-align: center">
            <p-button type="success" size="sm" icon @click="editMetadatum(props.row)">
              <i class="fa fa-edit"></i>
            </p-button>
            <p-button type="danger" :disabled="props.row.locked && cantEditMetadata" size="sm" icon @click="confirmDeleteMetadata(props.row)">
              <i class="fa fa-times"></i>
            </p-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="row form-group" style="padding: 10px 25px 0 25px">
      <div class="col-md-3">
        <label class="m-top-input">Name</label>
        <input type="text"
               placeholder="Name"
               name="name"
               ref="metadatumName"
               v-model="edit.name"
               v-validate="modelValidations.name"
               data-vv-as="name"
               class="form-control" />
        <small class="text-danger" v-show="errors.has('name')">
          {{ getError('name') }}
        </small>
      </div>
      <div class="col-md-3">
        <label class="m-top-input">Value</label>
        <input type="text"
               placeholder="Value"
               name="value"
               v-model="edit.value"
               v-validate="modelValidations.value"
               data-vv-as="value"
               class="form-control" />
        <small class="text-danger" v-show="errors.has('value')">
          {{ getError('value') }}
        </small>
      </div>
      <div class="col-md-2">
        <p-checkbox v-model="edit.locked" class="m-top-checkbox">Locked</p-checkbox>
      </div>
      <div class="col-md-2">
        <p-checkbox v-model="edit.active" class="m-top-checkbox">Active</p-checkbox>
      </div>
      <div class="col-md-2">
        <button style="margin-top: 35px;" @click="saveMetadatum" class="btn btn-fill btn-info btn-md btn-add-field-value">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapFields} from 'vee-validate'
  import Constants from 'src/utilities/constants'
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import {metadataNameExists} from 'src/utilities/validation'
  import {sync} from 'vuex-pathify'

  export default {
    props: ['data'],
    computed: {
      edit: sync('metadata@edit'),
      ...mapFields([
        'name',
        'value'
      ])
    },
    data () {
      return {
        metadatumToDelete: null,
        localTableData: [],
        modelValidations: {
          name: {
            required: true,
            max: 128,
            nameExists: true
          },
          value: {
            required: true,
            max: 128
          }
        },
        constants: Constants,
      }
    },
    methods: {
      cantEditMetadata () {
        return !(this.$can('manage', 'all') || this.$can('update', 'projectMetadata'))
      },
      editMetadatum(metadatum) {
        this.$store.commit('metadata/edit', JSON.parse(JSON.stringify(metadatum)))
      },
      async saveMetadatum () {
        if (await this.$validator.validateAll()) {
          const putPayload = this.$store.getters['metadata/putPayload']
          const response = await this.$store.dispatch('put', putPayload)
          this.$validator.pause()

          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            const edit = this.$store.getters['metadata/edit']
            this.$store.commit('metadata/updateMetadatum', {entity: this.data.entity, data: edit})
            notifySuccess(this, this.data.entity + ' Metadata Saved Successfully')
            this.localTableData = this.$store.getters['metadata/byEntity'](this.data.entity)
            this.$store.commit('metadata/resetEdit')
            this.$store.commit('metadata/editEntity', this.data.entity)
            this.$store.commit('metadata/editEntityId', this.data.entityId)
            this.$eventHub.$emit('projectMetadataUpdated')
          } else {
            notifyError(this, 'Failed to save ' + this.data.entity + ' Metadata')
          }

          // needs a slight delay to resume correctly
          setTimeout(this.resumeValidation, 250)
        }
      },
      confirmDeleteMetadata (metadatum) {
        this.metadatumToDelete = metadatum
        const payload = {
          message: 'Are you sure you want to delete <strong>' + metadatum.name + ': ' + metadatum.value + '</strong>?',
          entity: metadatum,
          delete: this.deleteMetadata,
          showButton: true
        }
        this.$eventHub.$emit('show-modal-2', 'Confirm Delete', payload, '600px')
      },
      async deleteMetadata () {
        const response = await this.$store.dispatch('metadata/delete', {entity: this.data.entity, data: this.metadatumToDelete})

        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          this.localTableData = this.$store.getters['metadata/byEntity'](this.data.entity)
          this.$eventHub.$emit('projectMetadataUpdated')
          notifySuccess(this, 'Successfully Deleted ' + this.data.entity + ' Metadata')
        } else {
          notifyError(this, 'Failed to Delete ' + this.data.entity + ' Metadata')
        }
      },
      resumeValidation () {
        this.$validator.resume()
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    mounted () {
      metadataNameExists(this.data.entity)
      this.localTableData = this.$store.getters['metadata/byEntity'](this.data.entity)
      this.$store.commit('metadata/resetEdit')
      this.$store.commit('metadata/editEntity', this.data.entity)
      this.$store.commit('metadata/editEntityId', this.data.entityId)

      this.$refs.metadatumName.focus()
    }
  }
</script>

<style scoped>
  .m-top-input {
    margin-top: 10px;
  }
  .m-top-checkbox {
    margin-top: 45px;
  }
</style>
